import React from 'react'
import ReactDOM from 'react-dom'
import { SentryInit } from './util/sentry'
import { installRecaptchaErrorGuard } from './util/recaptchaErrorGuard'
import App from './App'

installRecaptchaErrorGuard()
SentryInit()

ReactDOM.render(<App />, document.getElementById('root'))
